module.exports = __webpack_public_path__ + "static/media/rejectCall.e5833f3b.svg";